define('maps',[
  'settings', 
  'maprenderer',
  'gmapsapi'
], function(Settings, MapRenderer, GMapsAPI) {
  var Maps = {};

  Maps.render_maps = function(event_settings) {
  	var cb = function() { MapRenderer.render_maps(event_settings); };
  	GMapsAPI.load_api(cb);
  }

  return Maps;

});

